import { apiGet, apiPost, apiPut } from './api';


export const CATEGORIES = [
  'Equipamiento de Competición',
  'Cinturones',
  'Muñequeras y Rodilleras',
  'Barras y Discos',
  'Ropa de Entrenamiento',
  'Accesorios',
  'Suplementos'
];

export const DEFAULT_PRODUCTS = [];

export const getProducts = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.categoria_id) queryParams.append('categoria_id', params.categoria_id);
    if (params.search) queryParams.append('search', params.search);
    if (params.solo_destacados) queryParams.append('solo_destacados', params.solo_destacados);
    
    const queryString = queryParams.toString();
    const endpoint = `/api/ecommerce/productos${queryString ? `?${queryString}` : ''}`;
    
    const response = await apiGet(endpoint);
    const data = await response.json();
    
    if (data.success) {
      return {
        productos: data.data.productos || [],
        pagination: data.data.pagination || null
      };
    }
    
    return { productos: [], pagination: null };
  } catch (error) {
    console.error('Error al obtener productos:', error);
    return { productos: [], pagination: null };
  }
};

export const getProductById = async (id) => {
  try {
    const response = await apiGet(`/api/ecommerce/productos/${id}`);
    const data = await response.json();
    
    if (data.success) {
      return data.data.producto;
    }
    
    return null;
  } catch (error) {
    console.error('Error al obtener producto:', error);
    return null;
  }
};

export const getCategories = async () => {
  try {
    const response = await apiGet('/api/ecommerce/productos/categorias');
    const data = await response.json();
    
    if (data.success) {
      return data.data.categorias || [];
    }
    
    return [];
  } catch (error) {
    console.error('Error al obtener categorías:', error);
    return [];
  }
};

export const getFeaturedProducts = async (limit = 10) => {
  try {
    const response = await apiGet(`/api/ecommerce/productos/destacados?limit=${limit}`);
    const data = await response.json();
    
    if (data.success) {
      return data.data.productos || [];
    }
    
    return [];
  } catch (error) {
    console.error('Error al obtener productos destacados:', error);
    return [];
  }
};

export const getRelatedProducts = async (productId, limit = 4) => {
  try {
    const response = await apiGet(`/api/ecommerce/productos/${productId}/relacionados?limit=${limit}`);
    const data = await response.json();
    
    if (data.success) {
      return data.data.productos || [];
    }
    
    return [];
  } catch (error) {
    console.error('Error al obtener productos relacionados:', error);
    return [];
  }
};

export const saveProducts = async (products) => {
  try {
    if (Array.isArray(products)) {
      const promises = products.map(product => saveProduct(product));
      const results = await Promise.all(promises);
      return results;
    }
    
    return await saveProduct(products);
  } catch (error) {
    console.error('Error al guardar productos:', error);
    throw error;
  }
};

const saveProduct = async (product) => {
  try {
    const productData = {
      nombre: product.name,
      descripcion: product.description,
      precio: parseFloat(product.price),
      categoria: product.category,
      imagen_principal_url: product.image,
      stock: product.stock || 0,
      activo: product.active !== false,
      destacado: product.featured || false
    };

    if (product.id) {
      const response = await apiPut(`/api/ecommerce/productos/${product.id}`, productData);
      const data = await response.json();
      return data;
    } else {
      const response = await apiPost('/api/ecommerce/productos', productData);
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error('Error al guardar producto:', error);
    throw error;
  }
};

export const uploadProductImage = async (file, productId = null) => {

  
  try {
    const formData = new FormData();
    formData.append('image', file);
    
    if (productId) {
      formData.append('product_id', productId);
    }

    const token = localStorage.getItem('access_token');
    
    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5002';
    
    const fullURL = `${API_URL}/api/ecommerce/productos/upload-image`;
    
    const response = await fetch(
      fullURL,
      {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        },
        body: formData
      }
    );

    const data = await response.json();
        
    if (data.success) {
      return data.data.image_url;
    }
    
    console.error(' Upload falló - data.success es false:', data.error);
    throw new Error(data.error || 'Error al subir imagen');
  } catch (error) {
    console.error(' CATCH - Error en uploadProductImage:', error);
    console.error(' Error.message:', error.message);
    console.error('Error.stack:', error.stack);
    
    console.warn('⚠️ Endpoint de upload no disponible, usando placeholder');
    return `https://via.placeholder.com/400x400/dc2626/ffffff?text=${encodeURIComponent(file.name)}`;
  }
};

export const mapProductToFrontend = (product) => {
  const defaultImage = '/contenido-no-disponible.jpeg';
  
  return {
    id: product.id,
    name: product.nombre,
    description: product.descripcion,
    price: parseFloat(product.precio),
    discountPrice: product.precio_descuento ? parseFloat(product.precio_descuento) : null,
    category: product.categoria?.nombre || 'Sin categoría',
    category_id: product.categoria_id,
    image: product.imagen_principal_url || defaultImage,
    images: product.imagenes_adicionales || [],
    stock: product.stock,
    sku: product.sku,
    featured: product.destacado,
    active: product.activo,
    specifications: product.especificaciones || {}
  };
};


export const mapProductToBackend = (product) => {
  return {
    nombre: product.name,
    descripcion: product.description,
    precio: parseFloat(product.price),
    precio_descuento: product.discountPrice ? parseFloat(product.discountPrice) : null,
    categoria_id: product.category_id,
    imagen_principal_url: product.image,
    imagenes_adicionales: product.images || [],
    stock: product.stock || 0,
    sku: product.sku,
    destacado: product.featured || false,
    activo: product.active !== false,
    especificaciones: product.specifications || {}
  };
};

export default {
  CATEGORIES,
  DEFAULT_PRODUCTS,
  getProducts,
  getProductById,
  getCategories,
  getFeaturedProducts,
  getRelatedProducts,
  saveProducts,
  uploadProductImage,
  mapProductToFrontend,
  mapProductToBackend
};